/**
 * Detecta el error de "chunk viejo" — cuando el navegador tiene la app abierta
 * durante un deploy y trata de cargar un chunk (index-XXX.js) que ya no existe
 * porque el deploy nuevo reemplazó todos los assets. Usado por main.jsx (para
 * disparar el auto-reload) y por sentry.js (para no alertar por algo que ya
 * se autorrecupera solo) — un solo lugar para no desincronizar los mensajes.
 */
export function isChunkLoadError(err) {
  const m = String(err?.message || err || "");
  return m.includes("Failed to fetch dynamically imported module")
      || m.includes("Importing a module script failed")
      || m.includes("error loading dynamically imported module")
      || /Loading chunk \d+ failed/.test(m);
}
